import { takeLatest, call, select, put } from 'redux-saga/effects';

// Services
import { connectivityChipsApi } from 'services/apiDigitalTicket/connectivityChips';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

// Actions
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as ConnectivityChipsActions from './actions';

// Types
import { ConnectivityChipsTypes } from './types';

function* listConnectivityChips({
  payload,
}: ReturnType<typeof ConnectivityChipsActions.listConnectivityChipsRequest>): any {
  try {
    const { body } = payload;

    const transportOperator = yield select(
      (state: any) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(connectivityChipsApi.list, {
      params: {
        transportOperatorId: transportOperator.id,
        ...body,
      },
    });

    if (response.status === 200) {
      yield put(
        ConnectivityChipsActions.listConnectivityChipsSuccess({
          connectivityChips: response.data,
          totalCount: parseInt(response.headers.totalcount, 10) || 0,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('connectivityChips - listConnectivityChips - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ConnectivityChipsActions.listConnectivityChipsFailure());
  }
}

function* getConnectivityChip({
  payload,
}: ReturnType<typeof ConnectivityChipsActions.getConnectivityChipRequest>): any {
  try {
    const { id } = payload;

    const transportOperator = yield select(
      (state: any) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(connectivityChipsApi.get, {
      params: { id, transportOperatorId: transportOperator.id },
    });

    if (response.status === 200) {
      yield put(
        ConnectivityChipsActions.getConnectivityChipSuccess({
          connectivityChip: response.data,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('connectivityChips - getConnectivityChip - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ConnectivityChipsActions.getConnectivityChipFailure());
  }
}

export const connectivityChipsSagas = [
  takeLatest(ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_REQUEST, listConnectivityChips),
  takeLatest(ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_REQUEST, getConnectivityChip),
];
